import { UntypedFormControl } from '@angular/forms';

export interface IDynamicKeyFormControl {
    [key: string]: UntypedFormControl;
}
